export default __webpack_public_path__ + "static/media/screen-minha-encomenda-min.337ab438.png";